//export * from './src/app/index';

export { SYSMAN_ROUTES } from './src/app/app.routes';
export { SYSMAN_REDUCERS } from './src/app/app.stores';

export { SysmanModule } from './src/app/app.module';
export { AppComponent } from './src/app/app.component';





// WEBPACK FOOTER //
// ./~/@c4/sysman/index.ts